// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"970":"b0df9d817b36ffdf","996":"9111450c5212f81a","997":"0d8b360201325640"}[chunkId] + ".js";
};